(function () {

angular
        .module('genesis_app')
        .controller('LoginController', loginController);

    loginController.$inject = ['$scope', 'authService', '$location', '$cookies', 'UserSettingService'];

    function loginController($scope, authService, $location, $cookies, UserSettingService) {

        $scope.getDefaultLanguage = function () {
            var language;
            try {
                language = navigator.languages ? navigator.languages[0] : (navigator.language || navigator.userLanguage);
                if (language.startsWith('pt')) {
                    language = 'pt-br'
                }
                else {
                    language = 'en';
                }
            }
            catch (err) {
                language = 'pt-br';
            }
            //console.log('Default language = ' + language);
            return language;
        };

        var defaultLanguage = $scope.getDefaultLanguage();
        //console.log('loginController $scope.language: ' + $scope.language + ' defaultLanguage: ' + defaultLanguage);
        authService.setLanguage(defaultLanguage);

        $scope.auth = authService;
        var DEFAULT_DATABASE = 'GenesisAraupel';

        //JRM TESTES
        //DEFAULT_DATABASE = 'GenesisAraupelQua';

        var invitationId = $location.search().invitationId;
        var companyId = $location.search().companyId;
        var emailInvited = $location.search().emailInvited;
        if (invitationId && companyId && emailInvited) {
            $cookies.put('invitation', invitationId);
            if (authService.isAuthenticated()) {
                $scope.InvitationError = 'Faça o logout da sua conta para utilizar o convite.';
            } else {
                UserSettingService.checkInvitation(invitationId, emailInvited, companyId).then(function (response) {
                    if (response.data) {
                        authService.signup(invitationId, companyId, emailInvited);
                    }
                }, function (error) {
                    $scope.InvitationError = error.data.ExceptionMessage;
                });
            }
        } else {
            var companyID = $cookies.get('company-id');
            var logged = $cookies.get('logged');            

            //VERIFICA SHIPPINGDOCS anonymousmode
            console.log('login.js companyID: ' + companyID + ' logged: ' + logged);
            var path = $location.path();
            $scope.isAnonymous = false;
            if (path.indexOf('/shippingDocs/') > -1) {                
                companyId = 'GenesisAraupel';                
                if (!authService.isAuthenticated()) {
                    $scope.isAnonymous = true;
                    $cookies.put('logged', false);
                    console.log('anonymous mode ON');
                    return;
                }
                else {
                    console.log('anonymous mode OFF');
                }
            }            

            if (companyID && (companyID !== 'GenesisAraupel' && companyID !== 'GenesisAraupelQua' && companyID !== 'GenesisAraupelTests')) {
                companyID = null;
                authService.logout();
            }
            if (!authService.isAuthenticated() && !logged) {
                if (companyID) {
                    authService.login(companyID);
                    $cookies.put('logged', true);
                    return;
                } else {
                    authService.login(DEFAULT_DATABASE);
                    $cookies.put('logged', true);
                    return;
                }
            }
            setTimeout(function () {
                if (logged && !authService.isAuthenticated()) {
                    authService.login(DEFAULT_DATABASE);
                    $cookies.put('logged', true);
                }
            }, 5000);
        }
    }
})();
